import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SobCaptureConsent } from "./SobCaptureConsent";
import { SobQuestion } from "./SobQuestion";
import { SobThankYou } from "./SobThankYou";
import { useQuiz } from "./useQuiz";
export const SobQuiz = ({ data }) => {
    const { state, currentQuestion, isLoading, handleConsent, handleAnswer, consentData } = useQuiz(data);
    const { consentCaptureQuestion, questionScreen, finalScreen } = data;
    if (state.value === "declined" || !state.value) {
        return null;
    }
    return (_jsxs("div", { "data-testid": "sob-quiz", children: [state.value === "consent" && (_jsx(SobCaptureConsent, { isPending: isLoading, data: consentCaptureQuestion, onConsentSelect: handleConsent, consentData: consentData })), state.value === "quiz" && currentQuestion && (_jsx(SobQuestion, { isPending: isLoading, question: {
                    question: currentQuestion.question,
                    possibleAnswers: currentQuestion.possibleAnswers,
                }, title: questionScreen.title, description: questionScreen.description, onAnswerSelect: handleAnswer })), state.value === "completion" && _jsx(SobThankYou, { title: finalScreen.title, description: finalScreen.description })] }));
};
//# sourceMappingURL=SobQuiz.js.map